import { render, staticRenderFns } from "./my_academic_profile_usach_tab.vue?vue&type=template&id=b0a05414"
import script from "./my_academic_profile_usach_tab.vue?vue&type=script&lang=js"
export * from "./my_academic_profile_usach_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports